import { isPlatformBrowser } from '@angular/common'
import { Inject, Injectable, PLATFORM_ID } from '@angular/core'
import { LOCAL_STORAGE } from '@ng-web-apis/common'
import { Apollo, Query } from 'apollo-angular'
import { Observable, scan, Subject } from 'rxjs'
import { tap } from 'rxjs/operators'
import {
    ProductBySlugQuery,
    ProductBySlugQueryService,
    ProductBySlugQueryVariables,
} from '@app-graphql/schema'
import { Localization } from '@aa-app-localization'

@Injectable({ providedIn: 'root' })
export class ProductHistoryService {
    private slugSubject = new Subject<string>()

    public history$: Observable<Array<string>> = this.slugSubject.pipe(
        scan((acc, val) => {
            return [val, ...acc].slice(0, 6)
        }, JSON.parse(this.storage.getItem('recentItems') ?? '[]') as Array<string>),
        tap((recentItems) => {
            this.storage.setItem('recentItems', JSON.stringify(recentItems))
        }),
    )

    constructor(
        private productBySlugQueryService: ProductBySlugQueryService,
        @Inject(LOCAL_STORAGE) private storage: Storage,
        @Inject(PLATFORM_ID) private platformId: object,
    ) {
    }

    public fetch(
        variables: ProductBySlugQueryVariables,
        locale: Localization.Locale,
        options?: Query.FetchOptions<ProductBySlugQuery, ProductBySlugQueryVariables>,
    ): Observable<Apollo.QueryResult<ProductBySlugQuery>> {
        const fetchPolicy = isPlatformBrowser(this.platformId)
            ? 'network-only'
            : 'cache-only'

        return this.productBySlugQueryService.fetch({
            variables,
            ...options,
            fetchPolicy: options?.fetchPolicy ?? fetchPolicy,
        }).pipe(
            tap((result) => {
                if (result.data?.productBySlug?.translations[locale].slug) {
                    this.slugSubject.next(result.data.productBySlug.translations[locale].slug)
                }
            }),
        )
    }
}
